import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export enum ActionComparison {
  Any = 'Any',
  Created = 'Created',
  Modified = 'Modified',
}

@Component({
  selector: 'automata-crm-created-modified',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyFormFieldModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  template: `
    <glxy-form-field [required]="true">
      <glxy-label>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.CRM_TASK_CREATED_CONTACT.SELECT_LABEL' | translate }}</glxy-label>
      <mat-select [value]="value" (valueChange)="valueChanged($event)">
        <mat-option [value]="comparison.Any">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CRM_TASK_CREATED_CONTACT.CREATED_OR_MODIFIED' | translate }}
        </mat-option>
        <mat-option [value]="comparison.Created">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CRM_TASK_CREATED_CONTACT.CREATED' | translate }}
        </mat-option>
        <mat-option [value]="comparison.Modified">
          {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CRM_TASK_CREATED_CONTACT.MODIFIED' | translate }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
  `,
})
export class CrmCreatedModifiedSelectorComponent {
  @Input() value: ActionComparison = ActionComparison.Any;
  @Output() valueChange = new EventEmitter<ActionComparison>();
  comparison = ActionComparison;

  valueChanged(value: ActionComparison) {
    this.value = value;
    this.valueChange.emit(value);
  }
}
